<template>
  <div>
    <v-card class="cart market-view" elevation="1">
      <div class="cart-header" id="cartHeader">
        <div
          class="item cart-button"
          :class="[
            cartSection == 'bet' ? 'active' : 'deactivated',
            getCashout || getCashoutLive || (getCashoutV2 && getAuthenticated)
              ? 'item33'
              : 'item50',
          ]"
          @click="switchCartSection('bet')"
        >
          {{ $t('bet') }}
          <sup class="num-odds" v-if="getBet.odds.length > 0">{{
            getBet.odds.length
          }}</sup>
        </div>

        <div
          class="item my-bets"
          :class="[
            cartSection == 'myBets' ? 'active' : 'deactivated',
            getCashout || getCashoutLive || (getCashoutV2 && getAuthenticated)
              ? 'item33'
              : 'item50',
            isTerminalUser ? 'disabled' : '',
          ]"
          @click="!isTerminalUser && switchCartSection('myBets')"
        >
          {{ $t('myBets') }}
        </div>

        <template v-if="getAuthenticated">
          <div
            class="item my-bets item33"
            v-if="getCashoutV2 || getCashout || getCashoutLive"
            :class="[
              cartSection == 'myBetsCashout' ? 'active' : 'deactivated',
              getCashout || getCashoutLive ? 'item33' : 'item50',
            ]"
            @click="switchCartSection('myBetsCashout')"
          >
            {{ $t('Cashout') }}
          </div>
        </template>
      </div>
      <div class="cart-content" v-if="cartSection == 'bet'">
        <BetSlipMarketView v-if="getUseModalCart === false"></BetSlipMarketView>
        <BetSlipMarketViewForModalCart v-else></BetSlipMarketViewForModalCart>
      </div>
      <div class="cart-content" v-if="cartSection == 'myBets'">
        <MyBets></MyBets>
      </div>
      <template v-if="getCashoutV2 === true">
        <div class="cart-content" v-if="cartSection == 'myBetsCashout'">
          <myBetsCashoutV2></myBetsCashoutV2>
        </div>
      </template>
      <template v-else>
        <div class="cart-content" v-if="cartSection == 'myBetsCashout'">
          <myBetsCashout></myBetsCashout>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MyBets from '@/components/right_widgets/MyBets'
import myBetsCashout from '@/components/right_widgets/MyBetsCashout'
import BetSlipMarketView from '@/components/right_widgets/BetSlipMarketView'
import BetSlipMarketViewForModalCart from '@/components/right_widgets/BetSlipMarketViewForModalCart.vue'
import myBetsCashoutV2 from '@/components/right_widgets/MyBetsCashoutV2.vue'

export default {
  name: 'CartMarketView',
  components: {
    MyBets,
    BetSlipMarketView,
    myBetsCashout,
    myBetsCashoutV2,
    BetSlipMarketViewForModalCart,
  },
  data: () => ({
    cartSection: 'bet',
    other: 'item cart-button',
  }),
  computed: {
    ...mapGetters({
      getAuthenticated: 'user/getAuthenticated',
      getLanguage: 'settings/getLanguage',
      getBet: 'cart/getBet',
      getLoading: 'cart/getLoading',
      getCashout: 'settings/getCashout',
      getCashoutLive: 'settings/getCashoutLive',
      getCashoutV2: 'settings/getCashoutV2',
      isTerminalUser: 'user/isTerminalUser',
      getUseModalCart: 'uiConfig/useModalCart',
    }),
  },
  methods: {
    ...mapActions({
      setLoadingCart: 'cart/setLoadingCart',
    }),

    switchCartSection(section) {
      this.cartSection = section
    },
  },

  mounted() {
    this.$root.$on('sectionCart', () => {
      this.switchCartSection('bet')
    })
  },
}
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
